/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import List from 'gatsby-core-theme/src/components/organisms/toplist/list';
import keygen from '~helpers/keygen';
import Tabs from '~hooks/tabs';

const TopList = ({ module, toplistHeading, CustomRow, page }) => {
  const template = page?.template;

  if (module.items.length === 1) {
    const toplist = module.items[0];
    return (
      <List
        toplist={toplist}
        CustomRow={CustomRow}
        hasLoadMoreButton={toplist.show_load_more}
        initItemsCount={toplist.num_items_initial_load}
        loadItemsCount={toplist.num_items_load_more}
        pageTemplate={template}
      />
    );
  }

  return (
    <Tabs tabsAlign="right" gtmClass="toplist-tabs-menu-gtm">
      {module.items.map((toplist) => (
        <div label={toplist.title} key={keygen()}>
          {toplistHeading}
          <List
            toplist={toplist}
            CustomRow={CustomRow}
            hasLoadMoreButton={toplist.show_load_more}
            initItemsCount={toplist.num_items_initial_load}
            loadItemsCount={toplist.num_items_load_more}
            pageTemplate={template}
          />
        </div>
      ))}
    </Tabs>
  );
};

TopList.propTypes = {
  module: PropTypes.shape({ items: PropTypes.arrayOf(PropTypes.object) }),
  toplistHeading: PropTypes.element,
  CustomRow: PropTypes.func,
  page: PropTypes.shape({ template: PropTypes.string }),
};

export default TopList;
